export function safeBillingReturn(path: string | null): string | null {
  return path && /^\/(projects|services|databases|billing|mail)(\/|\?|#|$)/.test(path) && !path.includes('\\') ? path : null
}
export function topUpLink(currency: string, shortfall: string, returnTo: string): string {
  return `/billing?${new URLSearchParams({ add: '1', currency, amount: shortfall, returnTo })}`
}
/** What the button back out of Billing says. A customer who came from Mail
 *  is buying or resuming a mailbox, not confirming an upgrade, and a button
 *  that says "upgrade" to them reads as the wrong page. */
export function billingReturnLabel(returnTo: string): { label: string; hint: string } {
  if (/^\/mail(\/|\?|#|$)/.test(returnTo)) {
    return { label: 'Return to Mail', hint: 'After your balance is credited, go back to create or resume your mailbox.' }
  }
  return { label: 'Return to upgrade', hint: 'After your balance is credited, review and confirm your upgrade.' }
}
